import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-journey-tracker',
  templateUrl: './patient-journey-tracker.component.html',
  styleUrls: ['./patient-journey-tracker.component.scss']
})
export class PatientJourneyTrackerComponent implements OnInit {
  @Input() currentState: string = 'Booked';
  @Input() journeyType: 'OPD' | 'IPD' = 'OPD';

  opdSteps = ['Appointment', 'Checked In', 'Waiting', 'Consultation', 'Prescription', 'Billing', 'Completed'];
  ipdSteps = ['Appointment', 'OPD Consultation', 'Admission', 'Ward', 'Daily Progress', 'Discharge', 'Completed'];

  get steps() {
    return this.journeyType === 'OPD' ? this.opdSteps : this.ipdSteps;
  }

  getCurrentStepIndex() {
    // Map backend states to the tracker steps
    const stateMap: any = {
      'Booked': 0,
      'Confirmed': 0,
      'Checked In': 1,
      'Waiting': 2,
      'In Consultation': 3,
      'In Progress': 3, // Encounter mapping
      'Prescribed': 4,
      'Waiting Results': 4,
      'Billed': 5,
      'Completed': this.steps.length - 1,
      'Closed': this.steps.length - 1,
      // IPD Mappings
      'Pending': 2, // Admission Pending
      'Admitted': 3,
      'Discharged': 5
    };
    return stateMap[this.currentState] !== undefined ? stateMap[this.currentState] : 0;
  }

  ngOnInit(): void {}
}
